import { settings } from 'settings';
import Fetch from 'utils/fetch';
import { ShopArray } from './fetchInbound';

export async function fetchShopArray(): Promise<ShopArray[]> {
  try {
    const response: Response = await Fetch.get({
      url: `${settings.newApiUrl}/inbound/shopArray`,
    });

    if (response.ok) {
      const ShopArrayList: { shopArray: ShopArray[] } = await response.json();
      return ShopArrayList.shopArray;
    }
  } catch (error) {
    return [];
  }
}
